import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CaseType,
  CaseTypeSchemasQuery,
  CaseTypeSchemasQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { useFetchQuery } from "src/graphql/utils/useFetchQuery.ts";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getCaseTypesSchemasQuery = gql(/* GraphQL */ `
  query CaseTypeSchemas {
    schema {
      caseTypes {
        code
        name
      }
    }
  }
`) as TypedDocumentNode<CaseTypeSchemasQuery, CaseTypeSchemasQueryVariables>;

export const useGetCaseTypesSchemasQuery = () => {
  return useFetchQuery(getCaseTypesSchemasQuery, {
    toData: (data) => {
      return (data?.schema?.caseTypes as CaseType[]) ?? [];
    },
    isEmpty: (data) => isEmpty(data?.schema?.caseTypes),
    uiErrors: {
      fetchError: "FETCH-CASE-TYPES-ERROR",
      emptyError: "EMPTY-CASE-TYPES-ERROR",
    },
  });
};
